import { render, staticRenderFns } from "./upgradeList.vue?vue&type=template&id=e5551940&"
import script from "./upgradeList.vue?vue&type=script&lang=js&"
export * from "./upgradeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\svn\\家用后台\\branches\\20240430-1.5.0\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e5551940')) {
      api.createRecord('e5551940', component.options)
    } else {
      api.reload('e5551940', component.options)
    }
    module.hot.accept("./upgradeList.vue?vue&type=template&id=e5551940&", function () {
      api.rerender('e5551940', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/voice/upgrade/upgradeList.vue"
export default component.exports